import { Injectable } from "@angular/core";

@Injectable()
export class DeeplinksProvider {
  constructor() {}

  links = {
    "/tutorial-email-tel": "TutorialEmailTelPage",
    "/password-confirmation": "PasswordConfirmationPage"
  };
  match(hash: string = ""): Promise<any> {
    return new Promise((resolve, reject) => {
      let pageObj: any;
      for (const key in this.links) {
        const reg = new RegExp(key);
        const match: any = hash.match(reg);
        let token: any;
        if (match) {
          if (this.links[key] == "PasswordConfirmationPage") {
            token = hash.split("?token=")[1];
          }
          pageObj = {
            page: this.links[key],
            match: match,
            token: token
          };
          break;
        }
      }
      resolve(pageObj);
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/deeplinks/deeplinks.ts